import axios from 'axios'
import { EBO_API } from '~/utils/constants'

const instance = axios.create({
  baseURL: EBO_API,
  timeout: 60000,
})

export default instance
